<template>
	<div class="cont_ranking">
		<h3 class="screen_out">랭킹 목록</h3>
		<ul class="list_ranking">
			<slot></slot>
		</ul>
	</div>
</template>

<script>
export default {

}
</script>
